import { render, staticRenderFns } from "./aboutus1.vue?vue&type=template&id=3af3a5d6"
import script from "./aboutus1.vue?vue&type=script&lang=js"
export * from "./aboutus1.vue?vue&type=script&lang=js"
import style0 from "./aboutus1.vue?vue&type=style&index=0&id=3af3a5d6&prod&lang=css"
import style1 from "./aboutus1.vue?vue&type=style&index=1&id=3af3a5d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports